import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';

async function getSaldoCategoria(params): Promise<any> {
  const api = await getApi();
  const { data } = await api.get<any>('/fluxo_caixa/saldo_por_categoria/', {params});
  return data;
}

type QueryFnType = typeof getSaldoCategoria;

function useSaldoCategoria(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-saldo-categoria', params],
    queryFn: () =>  getSaldoCategoria(params),
  });
}

export { useSaldoCategoria };
